import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { FilterContext } from "../FilterContextProvider";
import { UserContext } from "../Auth/UserContextProvider";
import Logout from "../Auth/Logout";

const InventoryLayout = ({ children }) => {
  const chosen = "pt-4 pl-8 pr-4 text-blue-500 font-bold";
  const notChosen = "pt-4 pl-8 pr-4 hover:text-blue-500";
  const { filterData } = useContext(FilterContext);
  const { isAdmin } = useContext(UserContext);

  return (
    <div className="text-black ml-24 h-14 border-b bg-white">
      <div className="flex justify-between">
        <div className="flex flex-row mb-4 text-sm text-black h-14">
          {filterData.artist_name && (
            <div className="bg-blue-500 text-white h-14 flex p-4 font-semibold">
              {filterData.artist_name}
            </div>
          )}
          <NavLink
            to="/inventory/forecast"
            activeClassName={chosen}
            className={notChosen}
          >
            <p>Forecast</p>
          </NavLink>
          <NavLink
            to="/inventory/location"
            activeClassName={chosen}
            className={notChosen}
          >
            <p>Location</p>
          </NavLink>
          {isAdmin && (
            <NavLink
              to="/inventory/adjust"
              activeClassName={chosen}
              className={notChosen}
            >
              <p>Adjust</p>
            </NavLink>
          )}
          <NavLink
            to="/inventory/history"
            activeClassName={chosen}
            className={notChosen}
          >
            <p>History</p>
          </NavLink>
          <NavLink
            to="/inventory/manage"
            activeClassName={chosen}
            className={notChosen}
          >
            <p>Manage</p>
          </NavLink>
          <Logout></Logout>
        </div>
      </div>
      <div className="bg-gray-100 pb-8">{children}</div>
    </div>
  );
};

export default InventoryLayout;
